import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/creative-commons-remix': {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M247.6 8c141.8 0 248.4 110.1 248.4 248 0 147.1-118.5 248-248.4 248-134 0-247.6-109.5-247.6-248 0-132.9 104.7-248 247.6-248zM248.4 52.7c-118.2 0-203.7 97.9-203.7 203.3 0 109.8 91.2 202.8 203.7 202.8 103.2 0 202.8-81.1 202.8-202.8 0.1-113.8-90.2-203.3-202.8-203.3zM410.1 260.4l4.9 2.2v70c-7.2 3.6-63.4 27.5-67.3 28.8-6.5-1.8-113.7-46.8-137.3-56.2l-64.2 26.6-63.3-27.5v-63.8l59.3-24.8c-0.7-0.7-0.4 5-0.4-70.4l67.3-29.7 151.9 62.9v61.6zM339.7 341.9v-43.8h-0.4v-1.8l-113.8-46.5v45.2l113.8 46.9v-0.4zM347.2 284.3l39.9-16.4-36.8-15.5-39 16.4zM399.5 322.4v-43l-44.3 18.6v43.4z'
      }
    ]
  }
})
